//
// Emits a custom event with more convenient defaults.
//
export function emit(el, name, options = {}) {
    const event = new CustomEvent(name, {
        bubbles: true,
        cancelable: false,
        composed: true,
        detail: {},
        ...options,
    });
    el.dispatchEvent(event);
    return event;
}
//# sourceMappingURL=event.js.map